import en from "./en"

type Keys = keyof typeof en

export const dict = {
  "desktop.menu.app": "OpenTAG",
  "desktop.menu.file": "文件",
  "desktop.menu.edit": "编辑",
  "desktop.menu.view": "视图",
  "desktop.menu.go": "转到",
  "desktop.menu.window": "窗口",
  "desktop.menu.help": "帮助",
  "desktop.menu.checkForUpdates": "检查更新…",
  "desktop.menu.settings": "设置",
  "desktop.menu.reloadWebview": "重新加载 Webview",
  "desktop.menu.restart": "重启",
  "desktop.menu.exportLogs": "导出日志…",
  "desktop.menu.newSession": "新建会话",
  "desktop.menu.openProject": "打开项目…",
  "desktop.menu.newWindow": "新建窗口",
  "desktop.menu.closeWindow": "关闭窗口",
  "desktop.menu.undo": "撤销",
  "desktop.menu.redo": "重做",
  "desktop.menu.cut": "剪切",
  "desktop.menu.copy": "复制",
  "desktop.menu.paste": "粘贴",
  "desktop.menu.delete": "删除",
  "desktop.menu.selectAll": "全选",
  "desktop.menu.toggleSidebar": "切换侧边栏",
  "desktop.menu.toggleTerminal": "切换终端",
  "desktop.menu.toggleFileTree": "切换文件树",
  "desktop.menu.reload": "重新加载",
  "desktop.menu.toggleDeveloperTools": "切换开发人员工具",
  "desktop.menu.actualSize": "实际大小",
  "desktop.menu.zoomIn": "放大",
  "desktop.menu.zoomOut": "缩小",
  "desktop.menu.toggleFullScreen": "切换全屏显示",
  "desktop.menu.back": "后退",
  "desktop.menu.forward": "前进",
  "desktop.menu.previousSession": "上一个会话",
  "desktop.menu.nextSession": "下一个会话",
  "desktop.menu.previousProject": "上一个项目",
  "desktop.menu.nextProject": "下一个项目",
  "desktop.menu.minimize": "最小化",
  "desktop.menu.maximize": "最大化",
  "desktop.menu.documentation": "OpenTAG 文档",
  "desktop.menu.supportForum": "支持论坛",
  "desktop.menu.shareFeedback": "提供反馈",
  "desktop.menu.reportBug": "报告错误",
  "desktop.menu.ariaLabel": "OpenTAG 菜单",

  "desktop.updater.dialog.checkFailed.message": "检查更新失败。",
  "desktop.updater.dialog.checkFailed.title": "更新错误",
  "desktop.updater.dialog.upToDate.message": "你使用的是最新版本。",
  "desktop.updater.dialog.upToDate.title": "无可用更新",
  "desktop.updater.dialog.ready.message": "已下载更新 {{version}}。是否立即重启？",
  "desktop.updater.dialog.ready.title": "更新已就绪",
  "desktop.updater.dialog.restart": "重启",
  "desktop.updater.dialog.later": "稍后",

  "desktop.recovery.action.relaunch": "重新启动",
  "desktop.recovery.action.exportLogs": "导出日志",
  "desktop.recovery.action.keepWaiting": "继续等待",
  "desktop.recovery.action.quit": "退出",
  "desktop.recovery.loadFailed": "OpenTAG 加载失败",
  "desktop.recovery.terminated": "OpenTAG 窗口意外终止",
  "desktop.recovery.unresponsive": "OpenTAG 未响应",
  "desktop.recovery.unresponsive.detail": "你可以重新启动应用、打开日志或继续等待。",
  "desktop.recovery.loadFailed.detail": "窗口：{{window}}\nURL：{{url}}\n错误：{{code}} {{description}}",
  "desktop.recovery.terminated.detail": "窗口：{{window}}\n原因：{{reason}}\n代码：{{code}}",
  "desktop.recovery.unknown": "<未知>",

  "desktop.dialog.chooseFolder": "选择文件夹",
  "desktop.dialog.chooseFile": "选择文件",
  "desktop.dialog.saveFile": "保存文件",
  "desktop.dialog.files": "文件",
  "desktop.server.local": "本地服务器",

  "desktop.wsl.error.windowsOnly": "WSL 仅在 Windows 上可用",
  "desktop.wsl.error.unavailable": "WSL 不可用",
  "desktop.wsl.error.listInstalled": "无法列出已安装的 WSL 发行版",
  "desktop.wsl.error.listOnline": "无法列出在线 WSL 发行版",
  "desktop.wsl.error.executeDistro": "无法在发行版中执行命令",
  "desktop.wsl.error.installWsl": "WSL 安装失败",
  "desktop.wsl.error.installDistro": "无法安装发行版：{{distro}}",
  "desktop.wsl.error.installOpencode": "OpenTAG 安装失败",
  "desktop.wsl.error.alreadyAdded": "已添加 {{distro}}",
  "desktop.wsl.error.opencodeMissing": "此发行版中未安装 opencode",
  "desktop.wsl.error.opencodeCannotRun": "已安装 opencode，但无法运行",
  "desktop.wsl.error.opencodeNotInstalled": "{{distro}} 中未安装 OpenTAG",
  "desktop.wsl.error.updateVersion":
    "OpenTAG 更新已完成，但 {{distro}} 仍报告版本 {{installed}}；预期版本为 {{expected}}",
  "desktop.wsl.error.noVersion": "无版本信息",
  "desktop.wsl.error.serverExited": "WSL 服务器启动后退出（code={{code}} signal={{signal}}）",
  "desktop.wsl.error.serverExitedBeforeHealthy":
    "WSL 服务器在进入正常状态前退出（code={{code}} signal={{signal}}）{{output}}",
  "desktop.wsl.error.healthTimeout": "{{distro}} 的 Sidecar 运行状况检查在 {{timeout}}ms 后超时",
  "desktop.wsl.error.commandTimeout": "{{command}} {{args}} 在 {{timeout}}ms 后超时",
  "desktop.wsl.error.failedPort": "无法获取端口",

  "desktop.picker.error.notSelected": "文件选择器未选择文件",
  "desktop.picker.error.sizeLimit": "所选附件超过 {{limit}} MB 的限制",

  "command.category.suggested": "建议",
  "command.category.view": "视图",
  "command.category.project": "项目",
  "command.category.provider": "提供商",
  "command.category.server": "服务器",
  "command.category.session": "会话",
  "command.category.theme": "主题",
  "command.category.language": "语言",
  "command.category.file": "文件",
  "command.category.context": "上下文",
  "command.category.terminal": "终端",
  "command.category.model": "模型",
  "command.category.mcp": "MCP",
  "command.category.agent": "智能体",
  "command.category.permissions": "权限",
  "command.category.workspace": "工作区",
  "command.category.settings": "设置",
  "command.logs.export": "导出日志",
  "command.debugBar.toggle": "切换调试栏",

  "theme.scheme.system": "系统",
  "theme.scheme.light": "浅色",
  "theme.scheme.dark": "深色",

  "command.sidebar.toggle": "切换侧边栏",

  "command.project.open": "打开项目",
  "command.project.previous": "上一个项目",
  "command.project.next": "下一个项目",
  "command.project.index": "切换到项目 {{index}}",

  "command.provider.connect": "连接提供商",

  "command.server.switch": "切换服务器",

  "command.settings.open": "打开设置",

  "command.session.previous": "上一个会话",
  "command.session.next": "下一个会话",
  "command.session.previous.unseen": "上一个未读会话",
  "command.session.next.unseen": "下一个未读会话",
  "command.session.archive": "归档会话",
  "command.session.location.cycle": "依次切换会话位置",

  "command.palette": "命令面板",

  "command.theme.cycle": "切换主题",
  "command.theme.set": "使用主题：{{theme}}",
  "command.theme.scheme.cycle": "切换配色方案",
  "command.theme.scheme.set": "使用配色方案：{{scheme}}",

  "command.language.cycle": "切换语言",
  "command.language.set": "使用语言：{{language}}",

  "command.session.new": "新建会话",
  "command.session.import": "导入会话",

  "command.file.open": "打开文件",

  "command.tab.close": "关闭标签页",
  "command.tab.reopenClosed": "重新打开已关闭的标签页",

  "command.context.addSelection": "将所选内容添加到上下文",
  "command.context.addSelection.description": "添加当前文件中选中的行",

  "command.input.focus": "聚焦输入框",

  "command.terminal.toggle": "切换终端",

  "command.fileTree.toggle": "切换文件树",

  "command.review.toggle": "切换审查",

  "command.terminal.new": "新建终端",
  "command.terminal.new.description": "创建新的终端标签页",

  "command.steps.toggle": "切换步骤",
  "command.steps.toggle.description": "显示或隐藏当前消息的步骤",

  "command.message.previous": "上一条消息",
  "command.message.previous.description": "跳转到上一条用户消息",
  "command.message.next": "下一条消息",
  "command.message.next.description": "跳转到下一条用户消息",

  "command.model.choose": "选择模型",
  "command.model.choose.description": "选择不同的模型",

  "command.mcp.toggle": "启用或禁用 MCP 服务器",
  "command.mcp.toggle.description": "启用或禁用 MCP 服务器",

  "command.agent.cycle": "切换智能体",
  "command.agent.cycle.description": "切换到下一个智能体",
  "command.agent.cycle.reverse": "反向切换智能体",
  "command.agent.cycle.reverse.description": "切换到上一个智能体",

  "command.model.variant.cycle": "切换思考强度",
  "command.model.variant.cycle.description": "切换到下一个强度等级",

  "command.prompt.mode.shell": "Shell",
  "command.prompt.mode.normal": "Prompt",

  "command.permissions.autoaccept.enable": "自动接受权限",
  "command.permissions.autoaccept.disable": "停止自动接受权限",

  "command.workspace.toggle": "切换工作区",
  "command.workspace.toggle.description": "在侧边栏启用或禁用多个工作区",

  "command.session.undo": "撤销",
  "command.session.undo.description": "撤销上一条消息",
  "command.session.redo": "重做",
  "command.session.redo.description": "重做上一条撤销的消息",
  "command.session.compact": "压缩会话",
  "command.session.compact.description": "总结会话以减少上下文大小",
  "command.session.fork": "从消息创建新会话",
  "command.session.fork.description": "从之前的消息创建新会话",

  "command.session.export": "导出会话",
  "command.session.export.description": "将完整会话记录导出为 JSON",

  "palette.search.placeholder": "搜索文件、命令和会话",
  "palette.search.placeholder.home": "搜索命令和会话",
  "palette.empty": "未找到结果",
  "palette.group.commands": "命令",
  "palette.group.files": "文件",

  "dialog.provider.search.placeholder": "搜索提供商",
  "dialog.provider.empty": "未找到提供商",
  "dialog.provider.group.popular": "热门",
  "dialog.provider.group.other": "其他",
  "dialog.provider.custom.label": "自定义 OpenAI 兼容提供商",
  "dialog.provider.tag.recommended": "推荐",
  "dialog.provider.opencode.note": "精选模型，包括 Claude、GPT、Gemini 等",
  "dialog.provider.opencode.tagline": "可靠的优化模型",
  "dialog.provider.opencodeGo.tagline": "适合所有人的低成本订阅",
  "dialog.provider.anthropic.note": "通过 API 密钥直接使用 Claude 模型",
  "dialog.provider.copilot.note": "通过 GitHub Copilot 使用辅助编程 AI 模型",
  "dialog.provider.openai.note": "适合快速处理各类 AI 任务的 GPT 模型",
  "dialog.provider.google.note": "可快速生成结构化回复的 Gemini 模型",
  "dialog.provider.openrouter.note": "通过一个提供商使用所有受支持的模型",
  "dialog.provider.vercel.note": "通过智能路由统一使用 AI 模型",

  "dialog.model.select.title": "选择模型",
  "dialog.model.search.placeholder": "搜索模型",
  "dialog.model.empty": "未找到模型",
  "dialog.model.manage": "管理模型",
  "dialog.model.manage.description": "自定义模型选择器中显示的模型。",
  "dialog.model.manage.provider.toggle": "切换所有 {{provider}} 模型",
  "dialog.model.unpaid.freeModels.title": "OpenTAG 提供的免费模型",
  "dialog.model.unpaid.addMore.title": "从热门提供商添加更多模型",
  "dialog.model.unpaid.viewMoreProviders": "查看另外 70 多个提供商",

  "dialog.provider.viewAll": "查看更多提供商",

  "provider.connect.title": "连接 {{provider}}",
  "provider.connect.title.anthropicProMax": "登录 Anthropic",
  "provider.connect.selectMethod": "选择 {{provider}} 的登录方式。",
  "provider.connect.method.apiKey": "API 密钥",
  "provider.connect.method.browser": "浏览器",
  "provider.connect.method.headless": "无头模式",
  "provider.connect.status.inProgress": "正在授权…",
  "provider.connect.status.waiting": "等待授权…",
  "provider.connect.status.failed": "授权失败：{{error}}",
  "provider.connect.apiKey.description":
    "输入你的 {{provider}} API 密钥以连接账户，并在 OpenTAG 中使用 {{provider}} 模型。",
  "provider.connect.apiKey.label": "{{provider}} API 密钥",
  "provider.connect.apiKey.placeholder": "API 密钥",
  "provider.connect.apiKey.required": "API 密钥为必填项",
  "provider.connect.opencodeZen.line1": "OpenCode Zen 为你提供一组精选的可靠优化模型，用于代码智能体。",
  "provider.connect.opencodeZen.line2": "只需一个 API 密钥，你就能使用 Claude、GPT、Gemini、GLM 等模型。",
  "provider.connect.opencodeZen.visit.prefix": "访问 ",
  "provider.connect.opencodeZen.visit.link": "opencode.ai/zen",
  "provider.connect.opencodeZen.visit.suffix": " 获取你的 API 密钥。",
  "provider.connect.oauth.code.visit.prefix": "访问 ",
  "provider.connect.oauth.code.visit.link": "此链接",
  "provider.connect.oauth.code.visit.suffix": " 获取授权码，以连接你的账户并在 OpenTAG 中使用 {{provider}} 模型。",
  "provider.connect.oauth.code.label": "{{method}} 授权码",
  "provider.connect.oauth.code.placeholder": "授权码",
  "provider.connect.oauth.code.required": "授权码为必填项",
  "provider.connect.oauth.code.invalid": "授权码无效",
  "provider.connect.oauth.auto.visit.prefix": "访问 ",
  "provider.connect.oauth.auto.visit.link": "此链接",
  "provider.connect.oauth.auto.visit.suffix": " 并输入以下代码，以连接你的账户并在 OpenTAG 中使用 {{provider}} 模型。",
  "provider.connect.oauth.auto.confirmationCode": "确认码",
  "provider.connect.toast.connected.title": "{{provider}} 已连接",
  "provider.connect.toast.connected.description": "现在可以使用 {{provider}} 模型了。",

  "provider.custom.title": "自定义提供商",
  "provider.custom.unavailable": "此服务器上无法使用自定义提供商",
  "provider.custom.description.prefix": "配置与 OpenAI 兼容的提供商。请查看",
  "provider.custom.description.link": "提供商配置文档",
  "provider.custom.description.suffix": "。",
  "provider.custom.field.providerID.label": "提供商 ID",
  "provider.custom.field.providerID.placeholder": "myprovider",
  "provider.custom.field.providerID.description": "使用小写字母、数字、连字符或下划线",
  "provider.custom.field.name.label": "显示名称",
  "provider.custom.field.name.placeholder": "我的 AI 提供商",
  "provider.custom.field.baseURL.label": "基础 URL",
  "provider.custom.field.baseURL.placeholder": "https://api.myprovider.com/v1",
  "provider.custom.field.apiKey.label": "API 密钥",
  "provider.custom.field.apiKey.placeholder": "API 密钥",
  "provider.custom.field.apiKey.description": "可选。如果你通过请求头管理认证，可留空。",
  "provider.custom.models.label": "模型",
  "provider.custom.models.id.label": "ID",
  "provider.custom.models.id.placeholder": "model-id",
  "provider.custom.models.name.label": "名称",
  "provider.custom.models.name.placeholder": "显示名称",
  "provider.custom.models.remove": "移除模型",
  "provider.custom.models.add": "添加模型",
  "provider.custom.headers.label": "请求头（可选）",
  "provider.custom.headers.key.label": "请求头",
  "provider.custom.headers.key.placeholder": "Header-Name",
  "provider.custom.headers.value.label": "值",
  "provider.custom.headers.value.placeholder": "value",
  "provider.custom.headers.remove": "移除请求头",
  "provider.custom.headers.add": "添加请求头",
  "provider.custom.error.providerID.required": "提供商 ID 为必填项",
  "provider.custom.error.providerID.format": "请使用小写字母、数字、连字符或下划线",
  "provider.custom.error.providerID.exists": "该提供商 ID 已存在",
  "provider.custom.error.name.required": "显示名称为必填项",
  "provider.custom.error.baseURL.required": "基础 URL 为必填项",
  "provider.custom.error.baseURL.format": "必须以 http:// 或 https:// 开头",
  "provider.custom.error.required": "必填",
  "provider.custom.error.duplicate": "重复",

  "provider.disconnect.toast.disconnected.title": "{{provider}} 已断开连接",
  "provider.disconnect.toast.disconnected.description": "{{provider}} 模型已不再可用。",
  "provider.disconnect.toast.noCredentials.description": "未找到 {{provider}} 的可移除凭据。",
  "provider.disconnect.toast.failed.description": "无法断开 {{provider}} 连接。",

  "model.tag.free": "免费",
  "model.tag.latest": "最新",
  "model.provider.anthropic": "Anthropic",
  "model.provider.openai": "OpenAI",
  "model.provider.google": "Google",
  "model.provider.xai": "xAI",
  "model.provider.meta": "Meta",
  "model.input.text": "文本",
  "model.input.image": "图像",
  "model.input.audio": "音频",
  "model.input.video": "视频",
  "model.input.pdf": "PDF",
  "model.tooltip.allows": "支持：{{inputs}}",
  "model.tooltip.context.label": "上下文",
  "model.tooltip.inputs": "输入",
  "model.tooltip.model": "模型",
  "model.tooltip.provider": "提供商",
  "model.tooltip.reasoning": "推理",
  "model.tooltip.reasoning.allowed": "支持推理",
  "model.tooltip.reasoning.none": "不支持推理",
  "model.tooltip.context": "上下文上限 {{limit}}",

  "common.search.placeholder": "搜索",
  "common.goBack": "返回",
  "common.goForward": "前进",
  "common.loading": "加载中",
  "common.loading.ellipsis": "…",
  "common.cancel": "取消",
  "common.clear": "清除",
  "common.connect": "连接",
  "common.disconnect": "断开连接",
  "common.continue": "继续",
  "common.submit": "提交",
  "common.save": "保存",
  "common.saving": "保存中…",
  "common.default": "默认",
  "common.attachment": "附件",

  "prompt.placeholder.shell": "输入 shell 命令… {{example}}",
  "prompt.placeholder.normal": '随便问点什么… "{{example}}"',
  "prompt.placeholder.simple": "随便问点什么…",
  "prompt.placeholder.summarizeComments": "总结评论…",
  "prompt.placeholder.summarizeComment": "总结该评论…",
  "prompt.mode.shell": "Shell",
  "prompt.mode.normal": "Prompt",
  "prompt.mode.shell.exit": "按 esc 退出",
  "session.child.promptDisabled": "无法向子智能体会话发送提示词。",
  "session.child.backToParent": "返回主会话。",
  "prompt.example.1": "修复代码库中的一个 TODO",
  "prompt.example.2": "这个项目的技术栈是什么？",
  "prompt.example.3": "修复失败的测试",
  "prompt.example.4": "解释认证是如何工作的",
  "prompt.example.5": "查找并修复安全漏洞",
  "prompt.example.6": "为用户服务添加单元测试",
  "prompt.example.7": "重构这个函数，让它更易读",
  "prompt.example.8": "这个错误是什么意思？",
  "prompt.example.9": "帮我调试这个问题",
  "prompt.example.10": "生成 API 文档",
  "prompt.example.11": "优化数据库查询",
  "prompt.example.12": "添加输入校验",
  "prompt.example.13": "创建一个新的组件用于…",
  "prompt.example.14": "我该如何部署这个项目？",
  "prompt.example.15": "审查我的代码并给出最佳实践建议",
  "prompt.example.16": "为这个函数添加错误处理",
  "prompt.example.17": "解释这个正则表达式",
  "prompt.example.18": "把它转换成 TypeScript",
  "prompt.example.19": "在整个代码库中添加日志",
  "prompt.example.20": "哪些依赖已经过期？",
  "prompt.example.21": "帮我写一个迁移脚本",
  "prompt.example.22": "为这个接口实现缓存",
  "prompt.example.23": "给这个列表添加分页",
  "prompt.example.24": "创建一个 CLI 命令用于…",
  "prompt.example.25": "这里的环境变量是怎么工作的？",
  "prompt.popover.emptyResults": "没有匹配的结果",
  "prompt.popover.emptyCommands": "没有匹配的命令",
  "prompt.dropzone.label": "将图片、PDF 或文本文件拖放到此处",
  "prompt.dropzone.file.label": "拖放以 @提及文件",
  "prompt.slash.badge.custom": "自定义",
  "prompt.slash.badge.skill": "技能",
  "prompt.slash.badge.mcp": "mcp",
  "prompt.context.active": "当前",
  "prompt.context.includeActiveFile": "包含当前文件",
  "prompt.context.removeActiveFile": "从上下文移除活动文件",
  "prompt.context.removeFile": "从上下文移除文件",
  "prompt.action.attachFile": "附加文件",
  "prompt.menu.addImagesAndFiles": "添加文件及更多内容",
  "prompt.menu.imagesAndFiles": "图片和文件",
  "prompt.menu.commands": "命令",
  "prompt.menu.context": "上下文",
  "prompt.menu.shellCommand": "shell 命令",
  "prompt.attachment.remove": "移除附件",
  "prompt.action.send": "发送",
  "prompt.action.stop": "停止",
  "prompt.toast.attachmentDuplicate.title": "此文件已上传",
  "prompt.toast.uploading.percent": "{{percent}}%",
  "prompt.toast.uploading.cancel": "取消上传",
  "prompt.toast.uploading.cancelFile": "取消上传 {{filename}}",
  "prompt.toast.uploadFailed.title": "上传失败",
  "prompt.toast.modelAgentRequired.title": "请选择智能体和模型",
  "prompt.toast.modelAgentRequired.description": "发送提示前请先选择智能体和模型。",
  "prompt.toast.worktreeCreateFailed.title": "创建工作区失败",
  "prompt.toast.sessionCreateFailed.title": "创建会话失败",
  "prompt.toast.shellSendFailed.title": "发送 shell 命令失败",
  "prompt.toast.commandSendFailed.title": "发送命令失败",
  "prompt.toast.promptSendFailed.title": "发送提示失败",
  "prompt.toast.promptSendFailed.description": "无法获取会话",

  "dialog.mcp.title": "MCP 服务器",
  "dialog.mcp.description": "已启用 {{enabled}} / {{total}}",
  "dialog.mcp.empty": "未配置 MCP 服务器",

  "dialog.lsp.empty": "已根据文件类型自动检测 LSP",

  "dialog.plugins.empty": "在 opencode.json 中配置的插件",

  "mcp.status.connected": "已连接",
  "mcp.status.failed": "失败",
  "mcp.status.needs_auth": "需要授权",
  "mcp.auth.clickToAuthenticate": "点击进行授权",
  "mcp.status.disabled": "已禁用",

  "dialog.fork.empty": "没有可用于创建新会话的消息",

  "dialog.directory.search.placeholder": "搜索文件夹",
  "dialog.directory.empty": "未找到文件夹",
  "dialog.directory.action.selectFile": "选择文件",
  "dialog.directory.action.selectFolder": "选择文件夹",
  "dialog.directory.root": "根目录",
  "dialog.directory.parent": "上级目录",
  "dialog.directory.readError": "无法读取此文件夹",

  "dialog.server.title": "服务器",
  "dialog.server.description": "切换此应用连接的 OpenTAG 服务器。",
  "dialog.server.search.placeholder": "搜索服务器",
  "dialog.server.empty": "暂无服务器",
  "dialog.server.add.title": "添加服务器",
  "dialog.server.add.url": "服务器 URL",
  "dialog.server.add.placeholder": "http://localhost:4096",
  "dialog.server.add.error": "无法连接到服务器",
  "dialog.server.add.checking": "检查中…",
  "dialog.server.add.button": "添加服务器",
  "dialog.server.add.name": "服务器名称（可选）",
  "dialog.server.add.namePlaceholder": "Localhost",
  "dialog.server.add.password": "密码（可选）",
  "dialog.server.edit.title": "编辑服务器",
  "dialog.server.default.title": "默认服务器",
  "dialog.server.default.description": "应用启动时连接此服务器，而不是启动本地服务器。需要重启。",
  "dialog.server.default.none": "未选择服务器",
  "dialog.server.default.set": "将当前服务器设为默认",
  "dialog.server.default.clear": "清除",
  "dialog.server.action.remove": "移除服务器",
  "dialog.server.menu.edit": "编辑",
  "dialog.server.menu.default": "设为默认",
  "dialog.server.menu.defaultRemove": "取消默认",
  "dialog.server.menu.delete": "删除",
  "dialog.server.current": "当前服务器",
  "dialog.server.status.default": "默认",
  "wsl.server.add": "添加 WSL 服务器",
  "wsl.server.addShort": "添加 WSL",
  "wsl.server.label": "WSL",
  "wsl.server.menu.label": "WSL 服务器",
  "wsl.server.retryStart": "重试启动",
  "wsl.server.updating": "正在更新…",
  "wsl.onboarding.step.distro": "选择发行版",
  "wsl.onboarding.step.opencode": "OpenTAG",
  "wsl.onboarding.checkingRuntime": "正在检查 WSL…",
  "wsl.onboarding.restartRequired": "Windows 需要重启才能完成 WSL 安装。",
  "wsl.onboarding.ready": "WSL 已就绪。",
  "wsl.onboarding.required": "需要 WSL 才能继续。",
  "wsl.onboarding.checkingDistros": "正在检查发行版…",
  "wsl.onboarding.installingDistro": "正在安装 {{distro}}…",
  "wsl.onboarding.checkingDistro": "正在检查 {{distro}}…",
  "wsl.onboarding.listingDistros": "正在列出发行版…",
  "wsl.onboarding.distroReady": "{{distro}} 已就绪。",
  "wsl.onboarding.distroNotInstalled": "{{distro}} 尚未安装。",
  "wsl.onboarding.openDistroOnce": "打开一次 {{distro}} 以完成设置。",
  "wsl.onboarding.finishingDistro": "正在完成 {{distro}} 的设置。",
  "wsl.onboarding.pickDistro": "选择一个发行版，或在下方安装。",
  "wsl.onboarding.checkingOpencode": "正在检查 OpenTAG…",
  "wsl.onboarding.checkingOpencodeIn": "正在检查 {{distro}} 中的 OpenTAG…",
  "wsl.onboarding.updatingOpencode": "正在更新 OpenTAG…",
  "wsl.onboarding.updatingOpencodeIn": "正在更新 {{distro}} 中的 OpenTAG…",
  "wsl.onboarding.updateOpencodeIn": "更新 {{distro}} 中的 OpenTAG。",
  "wsl.onboarding.updateOpencode": "更新 OpenTAG",
  "wsl.onboarding.opencodeReadyIn": "{{distro}} 中的 OpenTAG 已就绪。",
  "wsl.onboarding.opencodeReady": "OpenTAG 已就绪。",
  "wsl.onboarding.installOpencodeIn": "在 {{distro}} 中安装 OpenTAG。",
  "wsl.onboarding.installOpencode": "安装 OpenTAG",
  "wsl.onboarding.chooseDistroFirst": "请先选择发行版。",
  "wsl.onboarding.loadFailed": "加载 WSL 状态失败。",
  "wsl.onboarding.loading": "加载中…",
  "wsl.onboarding.installedDistros": "已安装的发行版",
  "wsl.onboarding.checkAgain": "重新检查",
  "wsl.onboarding.distroStatus.ready": "已就绪",
  "wsl.onboarding.distroStatus.checking": "检查中…",
  "wsl.onboarding.distroStatus.opencodeMissing": "未安装 OpenTAG",
  "wsl.onboarding.distroStatus.missingTools": "缺少 bash、curl",
  "wsl.onboarding.distroStatus.unsupported": "不支持 · 请使用 WSL 2",
  "wsl.onboarding.needAnotherDistro": "需要其他发行版？",
  "wsl.onboarding.needAnotherDistroHint": "从 WSL 目录安装 Linux 发行版",
  "wsl.onboarding.wslNotInstalled.title": "未安装 WSL",
  "wsl.onboarding.wslNotInstalled.description": "OpenTAG 需要 WSL（Windows Subsystem for Linux）才能添加 WSL 服务器",
  "wsl.onboarding.wslUnavailable.title": "WSL 不可用",
  "wsl.onboarding.wslUnavailable.description": "OpenTAG 无法验证此设备上的 WSL。",
  "wsl.onboarding.installWsl": "安装 WSL",
  "wsl.onboarding.windowsRestartRequired": "重启 Windows 以完成 WSL 安装，然后重新打开 OpenTAG。",
  "wsl.onboarding.next": "下一步",
  "wsl.onboarding.refresh": "刷新",
  "wsl.onboarding.allDistrosAdded": "所有已安装的发行版均已添加。",
  "wsl.onboarding.noDistros": "尚未检测到发行版。",
  "wsl.onboarding.install": "安装",
  "wsl.onboarding.installing": "正在安装…",
  "wsl.onboarding.installDistro": "安装发行版",
  "wsl.onboarding.searchDistros": "搜索发行版",
  "wsl.onboarding.wsl2Required": "需要 WSL 2。",
  "wsl.onboarding.toolsRequired": "此发行版需要 bash 和 curl。",
  "wsl.onboarding.openTerminal": "打开终端",
  "wsl.onboarding.path": "路径：{{path}}",
  "wsl.onboarding.notFound": "未找到",
  "wsl.onboarding.version": "版本：{{version}}",
  "wsl.onboarding.unknown": "未知",
  "wsl.onboarding.desktopVersion": "桌面版 {{version}}",
  "wsl.onboarding.versionMismatch": "已安装版本与桌面应用版本不一致。",
  "wsl.onboarding.adding": "正在添加…",

  "dialog.project.edit.title": "编辑项目",
  "dialog.project.edit.name": "名称",
  "dialog.project.edit.icon": "图标",
  "dialog.project.edit.icon.alt": "项目图标",
  "dialog.project.edit.icon.hint": "点击或拖拽图片",
  "dialog.project.edit.icon.recommended": "建议：128x128px",
  "dialog.project.edit.color": "颜色",
  "dialog.project.edit.color.select": "选择颜色：{{color}}",
  "dialog.project.edit.worktree.startup": "工作区启动脚本",
  "dialog.project.edit.worktree.startup.description": "创建新工作区 (worktree) 后运行。",
  "dialog.project.edit.worktree.startup.placeholder": "例如 bun install",

  "dialog.usageExceeded.dontShowAgain": "不再显示",

  "context.breakdown.title": "上下文细分",
  "context.breakdown.system": "系统",
  "context.breakdown.user": "用户",
  "context.breakdown.assistant": "助手",
  "context.breakdown.tool": "工具调用",
  "context.breakdown.other": "其他",
  "context.systemPrompt.title": "系统提示词",
  "context.rawMessages.title": "原始消息",
  "context.export.session": "导出会话",

  "context.stats.session": "会话",
  "context.stats.messages": "消息数",
  "context.stats.provider": "提供商",
  "context.stats.model": "模型",
  "context.stats.limit": "上下文限制",
  "context.stats.totalTokens": "词元总数",
  "context.stats.usage": "使用率",
  "context.stats.inputTokens": "输入词元",
  "context.stats.outputTokens": "输出词元",
  "context.stats.reasoningTokens": "推理词元",
  "context.stats.cacheTokens": "缓存词元（读/写）",
  "context.stats.userMessages": "用户消息",
  "context.stats.assistantMessages": "助手消息",
  "context.stats.totalCost": "总成本",
  "context.stats.sessionCreated": "创建时间",
  "context.stats.lastActivity": "最后活动",
  "context.usage.tokens": "词元数",
  "context.usage.usage": "使用率",
  "context.usage.cost": "成本",
  "context.usage.clickToView": "点击查看上下文",
  "context.usage.view": "查看上下文用量",

  "language.en": "English",
  "language.zh": "简体中文",
  "language.zht": "繁體中文",
  "language.ko": "한국어",
  "language.de": "Deutsch",
  "language.es": "Español",
  "language.fr": "Français",
  "language.da": "Dansk",
  "language.ja": "日本語",
  "language.pl": "Polski",
  "language.ru": "Русский",
  "language.ar": "العربية",
  "language.no": "Norsk",
  "language.br": "Português (Brasil)",
  "language.bs": "Bosanski",
  "language.uk": "Українська",
  "language.th": "ไทย",
  "language.tr": "Türkçe",

  "toast.language.title": "语言",
  "toast.language.description": "已切换到{{language}}",
  "toast.theme.title": "主题已切换",
  "toast.scheme.title": "配色方案",
  "toast.workspace.enabled.title": "工作区已启用",
  "toast.workspace.enabled.description": "侧边栏现在显示多个工作树",
  "toast.workspace.disabled.title": "工作区已禁用",
  "toast.workspace.disabled.description": "侧边栏只显示主工作树",
  "toast.permissions.autoaccept.on.title": "正在自动接受权限",
  "toast.permissions.autoaccept.on.description": "权限请求将被自动批准",
  "toast.permissions.autoaccept.off.title": "已停止自动接受权限",
  "toast.permissions.autoaccept.off.description": "权限请求将需要批准",
  "toast.model.none.title": "未选择模型",
  "toast.model.none.description": "请先连接提供商以总结此会话",
  "toast.file.loadFailed.title": "加载文件失败",
  "toast.file.listFailed.title": "列出文件失败",
  "toast.context.noLineSelection.title": "未选择行",
  "toast.context.noLineSelection.description": "请先在文件标签中选择行范围。",
  "toast.session.unshare.success.title": "已取消分享会话",
  "toast.session.unshare.success.description": "会话已成功取消分享",
  "toast.session.unshare.failed.title": "取消分享失败",
  "toast.session.unshare.failed.description": "取消分享会话时发生错误",
  "toast.session.export.success.title": "会话已导出",
  "toast.session.export.success.description": "已将会话保存到 {{filename}}",
  "toast.session.export.failed.title": "导出会话失败",
  "toast.session.export.failed.description": "导出会话时发生错误",

  "toast.session.listFailed.title": "无法加载 {{project}} 的会话",
  "toast.update.title": "有可用更新",
  "toast.update.description": "OpenTAG 有新版本 ({{version}}) 可安装。",
  "toast.update.action.installRestart": "安装并重启",
  "toast.update.action.notYet": "稍后",

  "error.page.title": "出了点问题",
  "error.page.description": "加载应用程序时发生错误。",
  "error.page.description.localServerStartup": "启动本地服务器时发生错误。",
  "error.page.details.label": "错误详情",
  "error.page.action.restart": "重启",
  "error.page.action.report": "上报错误",
  "error.page.action.reported": "错误已上报",
  "error.page.action.exportLogs": "导出日志",
  "error.page.action.checking": "检查中…",
  "error.page.action.checkUpdates": "检查更新",
  "error.page.action.updateTo": "更新到 {{version}}",
  "error.page.report.prefix": "If the problem persists, return to the IT support portal:",
  "error.page.report.link": "opentag.nesiler.com",
  "error.page.report.discord": "在 Discord 上",
  "error.page.version": "版本：{{version}}",
  "error.dev.rootNotFound": "未找到根元素。你是不是忘了把它添加到 index.html？或者 id 属性拼写错了？",
  "error.serverSync.connectFailed": "无法连接到服务器。是否有服务器正在 `{{url}}` 运行？",

  "directory.error.invalidUrl": "URL 中的目录无效。",

  "error.chain.unknown": "未知错误",
  "error.chain.causedBy": "原因：",
  "error.chain.apiError": "API 错误",
  "error.chain.status": "状态：{{status}}",
  "error.chain.retryable": "可重试：{{retryable}}",
  "error.chain.responseBody": "响应内容：\n{{body}}",
  "error.chain.didYouMean": "你是不是想输入：{{suggestions}}",
  "error.chain.modelNotFound": "未找到模型：{{provider}}/{{model}}",
  "error.chain.checkConfig": "请检查你的配置 (opencode.json) 中的 provider/model 名称",
  "error.chain.mcpFailed": 'MCP 服务器 "{{name}}" 启动失败。注意：OpenTAG 暂不支持 MCP 认证。',
  "error.chain.providerAuthFailed": "提供商认证失败（{{provider}}）：{{message}}",
  "error.chain.providerInitFailed": '无法初始化提供商 "{{provider}}"。请检查凭据和配置。',
  "error.chain.configJsonInvalid": "配置文件 {{path}} 不是有效的 JSON(C)",
  "error.chain.configJsonInvalidWithMessage": "配置文件 {{path}} 不是有效的 JSON(C)：{{message}}",
  "error.chain.configDirectoryTypo":
    '{{path}} 中的目录 "{{dir}}" 无效。请将目录重命名为 "{{suggestion}}" 或移除它。这是一个常见拼写错误。',
  "error.chain.configFrontmatterError": "无法解析 {{path}} 中的 frontmatter：\n{{message}}",
  "error.chain.configInvalid": "配置文件 {{path}} 无效",
  "error.chain.configInvalidWithMessage": "配置文件 {{path}} 无效：{{message}}",

  "notification.permission.title": "需要权限",
  "notification.permission.description": "{{sessionTitle}}（{{projectName}}）需要权限",
  "notification.question.title": "问题",
  "notification.question.description": "{{sessionTitle}}（{{projectName}}）有一个问题",
  "notification.action.goToSession": "前往会话",
  "notification.session.responseReady.title": "回复已就绪",
  "notification.session.error.title": "会话错误",
  "notification.session.error.fallbackDescription": "发生错误",

  "home.recentProjects": "最近项目",
  "home.empty.title": "没有最近项目",
  "home.empty.description": "通过打开本地项目开始使用",
  "home.title": "主页",
  "home.projects": "项目",
  "home.project.add": "添加项目",
  "home.recentlyClosed": "最近关闭",
  "home.server.collapse": "折叠服务器项目",
  "home.server.expand": "展开服务器项目",
  "home.sessions.search.placeholder": "搜索会话",
  "home.sessions.search.placeholder.scoped": "在 {{scope}} 中搜索会话",
  "home.sessions.search.sessions": "会话",
  "home.sessions.search.noResults": "未找到与 {{query}} 相关的会话",
  "home.sessions.empty": "这里还没有内容",
  "home.sessions.empty.description": "创建一个会话以开始。",
  "home.sessions.group.today": "今天",
  "home.sessions.group.yesterday": "昨天",
  "home.sessions.group.older": "更早",
  "home.providerTip": "连接 75 个以上的提供商，使用包括 Claude、GPT、Gemini 在内的更多模型",

  "session.tab.session": "会话",
  "session.tab.review": "审查",
  "session.tab.context": "上下文",
  "session.tab.unknown": "未知会话",
  "session.panel.reviewAndFiles": "审查和文件",
  "session.error.notFound": "找不到此会话",
  "session.error.notFound.description": "此标签页指向的会话已不存在于此服务器上。",
  "session.error.notFound.closeTab": "关闭标签页",
  "session.error.serverConnection": "无法连接到此服务器",
  "session.review.filesChanged": "{{count}} 个文件已更改",
  "session.review.change.one": "更改",
  "session.review.change.other": "更改",
  "session.review.loadingChanges": "正在加载更改…",
  "session.review.empty": "此会话暂无更改",
  "session.review.noVcs": "未检测到 Git，无法显示更改",
  "session.review.noSnapshot": "配置中已禁用快照跟踪，因此会话更改不可用",
  "session.review.noChanges": "无更改",
  "session.review.noUncommittedChanges": "尚无未提交的更改",
  "session.review.noBranchChanges": "尚无分支更改",
  "session.files.selectToOpen": "选择要打开的文件",
  "session.files.all": "所有文件",
  "session.files.empty": "无文件",
  "session.files.binaryContent": "二进制文件（无法显示内容）",
  "session.messages.renderEarlier": "显示更早的消息",
  "session.messages.loadingEarlier": "正在加载更早的消息…",
  "session.messages.loadEarlier": "加载更早的消息",
  "session.messages.loading": "正在加载消息…",
  "session.messages.jumpToLatest": "跳转到最新",
  "session.context.addToContext": "将 {{selection}} 添加到上下文",
  "session.todo.title": "待办事项",
  "session.todo.collapse": "折叠",
  "session.todo.expand": "展开",
  "session.question.minimize": "收起问题",
  "session.question.restore": "展开问题",
  "session.question.pending.one": "{{count}} 个待处理问题",
  "session.question.pending.other": "{{count}} 个待处理问题",
  "session.new.title": "构建任何内容",
  "session.new.project.new": "新建项目",
  "session.new.project.search": "搜索项目",
  "session.new.project.add": "添加项目",
  "session.new.worktree.main": "主分支",
  "session.new.worktree.mainWithBranch": "主分支（{{branch}}）",
  "session.new.worktree.create": "创建新的 worktree",
  "session.new.workspace.runIn": "运行会话的位置",
  "session.new.workspace.triggerLocal": "本地",
  "session.new.workspace.local": "本地仓库",
  "session.new.workspace.existing": "工作区…",
  "session.new.git.none": "无 Git",
  "session.new.lastModified": "最后修改",
  "session.header.search.placeholder": "搜索 {{project}}",
  "session.header.searchFiles": "搜索文件",
  "session.header.openIn": "打开方式",
  "session.header.open.action": "打开 {{app}}",
  "session.header.open.ariaLabel": "在 {{app}} 中打开",
  "session.header.open.menu": "打开选项",
  "session.header.open.copyPath": "复制路径",

  "status.popover.trigger": "状态",
  "status.popover.ariaLabel": "服务器配置",
  "status.popover.tab.servers": "服务器",
  "status.popover.tab.mcp": "MCP",
  "status.popover.tab.lsp": "LSP",
  "status.popover.tab.plugins": "插件",
  "status.popover.action.manageServers": "管理服务器",

  "common.copied": "已复制",

  "lsp.tooltip.none": "没有 LSP 服务器",
  "lsp.label.connected": "{{count}} LSP",

  "prompt.loading": "正在加载提示…",

  "terminal.loading": "正在加载终端…",
  "terminal.title": "终端",
  "terminal.title.numbered": "终端 {{number}}",
  "terminal.close": "关闭终端",
  "terminal.connectionLost.title": "连接已丢失",
  "terminal.connectionLost.description": "终端连接已中断。这可能发生在服务器重启时。",
  "terminal.connectTicket.csrfError": "PTY 连接票证因来源或 CSRF 检查被拒绝。请检查服务器 CORS 配置。",
  "terminal.connectTicket.statusError": "PTY 连接票证失败，状态为 {{status}}",

  "titlebar.update": "更新",
  "titlebar.updateVersion": "更新 {{version}}",

  "common.closeTab": "关闭标签页",
  "common.dismiss": "忽略",
  "common.requestFailed": "请求失败",
  "common.moreOptions": "更多选项",
  "common.learnMore": "了解更多",
  "common.rename": "重命名",
  "common.export": "导出",
  "common.reset": "重置",
  "common.archive": "归档",
  "common.delete": "删除",
  "common.close": "关闭",
  "common.edit": "编辑",
  "common.loadMore": "加载更多",
  "common.key.esc": "ESC",

  "sidebar.menu.toggle": "切换菜单",
  "sidebar.nav.projectsAndSessions": "项目和会话",
  "sidebar.settings": "设置",
  "sidebar.help": "帮助",
  "sidebar.workspaces.enable": "启用工作区",
  "sidebar.workspaces.disable": "禁用工作区",
  "sidebar.gettingStarted.title": "入门",
  "sidebar.gettingStarted.line1": "OpenTAG 提供免费模型，你可以立即开始使用。",
  "sidebar.gettingStarted.line2": "连接任意提供商即可使用更多模型，如 Claude、GPT、Gemini 等。",
  "sidebar.project.recentSessions": "最近会话",
  "sidebar.project.viewAllSessions": "查看全部会话",
  "sidebar.project.clearNotifications": "清除通知",
  "sidebar.empty.title": "没有打开的项目",
  "sidebar.empty.description": "打开一个项目以开始使用",

  "app.name.desktop": "OpenTAG Desktop",

  "settings.section.desktop": "桌面",
  "settings.section.server": "服务器",

  "settings.tab.general": "通用",
  "settings.tab.shortcuts": "快捷键",

  "settings.desktop.section.wsl": "WSL",
  "settings.desktop.wsl.title": "WSL 集成",
  "settings.desktop.wsl.description": "在 Windows 的 WSL 环境中运行 OpenTAG 服务器。",

  "settings.general.section.appearance": "外观",
  "settings.general.section.advanced": "高级",
  "settings.general.section.notifications": "系统通知",
  "settings.general.section.updates": "更新",
  "settings.general.section.sounds": "音效",
  "settings.general.section.feed": "动态",
  "settings.general.section.display": "显示",
  "settings.general.row.language.title": "语言",
  "settings.general.row.language.description": "更改 OpenTAG 的显示语言",
  "settings.general.row.shell.title": "终端 Shell",
  "settings.general.row.shell.description": "选择终端使用的 shell。兼容的 shell 也会用于智能体工具调用。",
  "settings.general.row.shell.autoDefault": "自动（默认）",
  "settings.general.row.shell.terminalOnly": "仅终端",
  "settings.general.row.appearance.title": "外观",
  "settings.general.row.appearance.description": "自定义 OpenTAG 在你的设备上的外观",
  "settings.general.row.colorScheme.title": "配色方案",
  "settings.general.row.colorScheme.description": "选择 OpenTAG 跟随系统、浅色或深色主题",
  "settings.general.row.theme.title": "主题",
  "settings.general.row.theme.description": "自定义 OpenTAG 的主题。",
  "settings.general.row.font.title": "代码字体",
  "settings.general.row.font.description": "自定义代码块使用的字体",
  "settings.general.row.terminalFont.title": "终端字体",
  "settings.general.row.terminalFont.description": "自定义终端使用的字体",
  "settings.general.row.uiFont.title": "界面字体",
  "settings.general.row.uiFont.description": "自定义整个界面使用的字体",
  "settings.general.row.showFileTree.title": "文件树",
  "settings.general.row.showFileTree.description": "在会话中显示文件树面板",
  "settings.general.row.showNavigation.title": "导航控件",
  "settings.general.row.showNavigation.description": "在桌面版标题栏中显示前进和后退按钮",
  "settings.general.row.showSearch.title": "命令面板",
  "settings.general.row.showSearch.description": "在标题栏中显示搜索和命令面板按钮",
  "settings.general.row.showTerminal.title": "终端",
  "settings.general.row.showTerminal.description": "在桌面版标题栏中显示终端按钮",
  "settings.general.row.showStatus.title": "服务器状态",
  "settings.general.row.showStatus.description": "在标题栏中显示服务器状态按钮",
  "settings.general.row.mobileTitlebarBottom.title": "底部导航",
  "settings.general.row.mobileTitlebarBottom.description": "在移动设备上将标题栏和会话标签页置于屏幕底部",
  "settings.general.row.showCustomAgents.title": "显示智能体",
  "settings.general.row.showCustomAgents.description": "在输入框中切换智能体。隐藏时默认使用 Build 智能体。",
  "settings.general.row.reasoningSummaries.title": "显示推理摘要",
  "settings.general.row.reasoningSummaries.description": "在时间线中显示模型推理摘要",
  "settings.general.row.shellToolPartsExpanded.title": "展开 Shell 工具调用",
  "settings.general.row.shellToolPartsExpanded.description": "默认在时间线中展开 Shell 工具调用详情",
  "settings.general.row.editToolPartsExpanded.title": "展开编辑工具调用",
  "settings.general.row.editToolPartsExpanded.description": "默认在时间线中展开 edit、write 和 patch 工具调用详情",
  "settings.general.row.pinchZoom.title": "双指缩放",
  "settings.general.row.pinchZoom.description": "允许使用触控板双指捏合和 Ctrl+滚轮手势缩放",
  "settings.general.row.wayland.title": "使用原生 Wayland",
  "settings.general.row.wayland.description": "在 Wayland 上禁用 X11 回退。需要重启。",
  "settings.general.row.wayland.tooltip": "在混合刷新率显示器的 Linux 系统上，原生 Wayland 可能更稳定。",
  "settings.general.row.releaseNotes.title": "发行说明",
  "settings.general.row.releaseNotes.description": "更新后显示“新功能”弹窗",

  "settings.updates.row.startup.title": "启动时检查更新",
  "settings.updates.row.startup.description": "在 OpenTAG 启动时自动检查更新",
  "settings.updates.row.check.title": "检查更新",
  "settings.updates.row.check.description": "手动检查更新并在有更新时安装",
  "settings.updates.action.checkNow": "立即检查",
  "settings.updates.action.checking": "正在检查…",
  "settings.updates.action.downloading": "正在下载…",
  "settings.updates.action.download": "下载 OpenTAG",
  "settings.updates.migration.title": "从 Beta 版迁移到稳定版",
  "settings.updates.migration.description":
    "OpenTAG Beta 目前正在迁移至 OpenTAG 稳定版。请下载 {{version}} 版本，然后从磁盘映像安装 OpenTAG，以继续接收更新。",
  "settings.updates.action.installing": "正在安装…",
  "settings.updates.toast.latest.title": "已是最新版本",
  "settings.updates.toast.latest.description": "你正在使用最新版本的 OpenTAG。",

  "sound.option.none": "无",
  "sound.option.alert01": "警报 01",
  "sound.option.alert02": "警报 02",
  "sound.option.alert03": "警报 03",
  "sound.option.alert04": "警报 04",
  "sound.option.alert05": "警报 05",
  "sound.option.alert06": "警报 06",
  "sound.option.alert07": "警报 07",
  "sound.option.alert08": "警报 08",
  "sound.option.alert09": "警报 09",
  "sound.option.alert10": "警报 10",
  "sound.option.bipbop01": "Bip-bop 01",
  "sound.option.bipbop02": "Bip-bop 02",
  "sound.option.bipbop03": "Bip-bop 03",
  "sound.option.bipbop04": "Bip-bop 04",
  "sound.option.bipbop05": "Bip-bop 05",
  "sound.option.bipbop06": "Bip-bop 06",
  "sound.option.bipbop07": "Bip-bop 07",
  "sound.option.bipbop08": "Bip-bop 08",
  "sound.option.bipbop09": "Bip-bop 09",
  "sound.option.bipbop10": "Bip-bop 10",
  "sound.option.staplebops01": "Staplebops 01",
  "sound.option.staplebops02": "Staplebops 02",
  "sound.option.staplebops03": "Staplebops 03",
  "sound.option.staplebops04": "Staplebops 04",
  "sound.option.staplebops05": "Staplebops 05",
  "sound.option.staplebops06": "Staplebops 06",
  "sound.option.staplebops07": "Staplebops 07",
  "sound.option.nope01": "Nope 01",
  "sound.option.nope02": "Nope 02",
  "sound.option.nope03": "Nope 03",
  "sound.option.nope04": "Nope 04",
  "sound.option.nope05": "Nope 05",
  "sound.option.nope06": "Nope 06",
  "sound.option.nope07": "Nope 07",
  "sound.option.nope08": "Nope 08",
  "sound.option.nope09": "Nope 09",
  "sound.option.nope10": "Nope 10",
  "sound.option.nope11": "Nope 11",
  "sound.option.nope12": "Nope 12",
  "sound.option.yup01": "Yup 01",
  "sound.option.yup02": "Yup 02",
  "sound.option.yup03": "Yup 03",
  "sound.option.yup04": "Yup 04",
  "sound.option.yup05": "Yup 05",
  "sound.option.yup06": "Yup 06",

  "settings.general.notifications.agent.title": "智能体",
  "settings.general.notifications.agent.description": "当智能体完成或需要注意时显示系统通知",
  "settings.general.notifications.permissions.title": "权限",
  "settings.general.notifications.permissions.description": "当需要权限时显示系统通知",
  "settings.general.notifications.errors.title": "错误",
  "settings.general.notifications.errors.description": "发生错误时显示系统通知",
  "settings.general.sounds.agent.title": "智能体",
  "settings.general.sounds.agent.description": "当智能体完成或需要注意时播放声音",
  "settings.general.sounds.permissions.title": "权限",
  "settings.general.sounds.permissions.description": "当需要权限时播放声音",
  "settings.general.sounds.errors.title": "错误",
  "settings.general.sounds.errors.description": "发生错误时播放声音",

  "settings.shortcuts.title": "键盘快捷键",
  "settings.shortcuts.reset.button": "重置为默认值",
  "settings.shortcuts.reset.toast.title": "快捷键已重置",
  "settings.shortcuts.reset.toast.description": "键盘快捷键已重置为默认设置。",
  "settings.shortcuts.conflict.title": "快捷键已被占用",
  "settings.shortcuts.conflict.description": "{{keybind}} 已分配给 {{titles}}。",
  "settings.shortcuts.unassigned": "未设置",
  "settings.shortcuts.pressKeys": "按下按键",
  "settings.shortcuts.search.placeholder": "搜索快捷键",
  "settings.shortcuts.search.empty": "未找到快捷键",
  "settings.shortcuts.group.general": "通用",
  "settings.shortcuts.group.session": "会话",
  "settings.shortcuts.group.navigation": "导航",
  "settings.shortcuts.group.modelAndAgent": "模型与智能体",
  "settings.shortcuts.group.terminal": "终端",
  "settings.shortcuts.group.prompt": "提示",

  "settings.providers.title": "提供商",
  "settings.providers.description": "可在此处配置提供商设置。",
  "settings.providers.section.connected": "已连接的提供商",
  "settings.providers.connected.empty": "没有已连接的提供商",
  "settings.providers.section.popular": "热门提供商",
  "settings.providers.tag.environment": "环境",
  "settings.providers.tag.config": "配置",
  "settings.providers.tag.custom": "自定义",
  "settings.providers.tag.other": "其他",

  "settings.models.title": "模型",
  "settings.models.description": "可在此处配置模型设置。",

  "settings.agents.title": "智能体",
  "settings.agents.description": "可在此处配置智能体设置。",

  "settings.commands.title": "命令",
  "settings.commands.description": "可在此处配置命令设置。",

  "settings.mcp.title": "MCP",
  "settings.mcp.description": "可在此处配置 MCP 设置。",

  "settings.permissions.title": "权限",
  "settings.permissions.description": "控制服务器默认可以使用哪些工具。",
  "settings.permissions.section.tools": "工具",
  "settings.permissions.toast.updateFailed.title": "更新权限失败",
  "settings.permissions.action.allow": "允许",
  "settings.permissions.action.ask": "询问",
  "settings.permissions.action.deny": "拒绝",
  "settings.permissions.tool.read.title": "读取",
  "settings.permissions.tool.read.description": "读取文件（匹配文件路径）",
  "settings.permissions.tool.edit.title": "编辑",
  "settings.permissions.tool.edit.description": "修改文件，包括编辑、写入和应用补丁",
  "settings.permissions.tool.glob.title": "Glob",
  "settings.permissions.tool.glob.description": "使用 glob 模式匹配文件",
  "settings.permissions.tool.grep.title": "Grep",
  "settings.permissions.tool.grep.description": "使用正则表达式搜索文件内容",
  "settings.permissions.tool.list.title": "列出文件",
  "settings.permissions.tool.list.description": "列出目录中的文件",
  "settings.permissions.tool.bash.title": "Bash",
  "settings.permissions.tool.bash.description": "运行 shell 命令",
  "settings.permissions.tool.task.title": "任务",
  "settings.permissions.tool.task.description": "启动子智能体",
  "settings.permissions.tool.skill.title": "技能",
  "settings.permissions.tool.skill.description": "按名称加载技能",
  "settings.permissions.tool.lsp.title": "LSP",
  "settings.permissions.tool.lsp.description": "运行语言服务器查询",
  "settings.permissions.tool.todowrite.title": "更新待办",
  "settings.permissions.tool.todowrite.description": "更新待办列表",
  "settings.permissions.tool.webfetch.title": "获取网页",
  "settings.permissions.tool.webfetch.description": "从 URL 获取内容",
  "settings.permissions.tool.websearch.title": "网页搜索",
  "settings.permissions.tool.websearch.description": "搜索网页",
  "settings.permissions.tool.external_directory.title": "外部目录",
  "settings.permissions.tool.external_directory.description": "访问项目目录之外的文件",
  "settings.permissions.tool.doom_loop.title": "死循环",
  "settings.permissions.tool.doom_loop.description": "检测具有相同输入的重复工具调用",

  "session.delete.failed.title": "删除会话失败",
  "session.delete.title": "删除会话",
  "session.delete.confirm": '删除会话 "{{name}}"？',
  "session.delete.button": "删除会话",

  "workspace.new": "新建工作区",
  "workspace.type.local": "本地",
  "workspace.type.sandbox": "沙盒",
  "workspace.create.failed.title": "创建工作区失败",
  "workspace.delete.failed.title": "删除工作区失败",
  "workspace.resetting.title": "正在重置工作区",
  "workspace.resetting.description": "这可能需要一点时间。",
  "workspace.reset.failed.title": "重置工作区失败",
  "workspace.reset.success.title": "工作区已重置",
  "workspace.reset.success.description": "工作区现已与默认分支一致。",
  "workspace.error.stillPreparing": "工作区仍在准备中",
  "workspace.status.checking": "正在检查未合并的更改…",
  "workspace.status.error": "无法验证 Git 状态。",
  "workspace.status.clean": "未检测到未合并的更改。",
  "workspace.status.dirty": "检测到未合并的更改。",
  "workspace.delete.title": "删除工作区",
  "workspace.delete.button": "删除工作区",
  "workspace.reset.title": "重置工作区",
  "workspace.reset.confirm": '重置工作区 "{{name}}"？',
  "workspace.reset.button": "重置工作区",
  "workspace.reset.archived.none": "不会归档任何活跃会话。",
  "workspace.reset.archived.one": "将归档 1 个会话。",
  "workspace.reset.archived.many": "将归档 {{count}} 个会话。",
  "workspace.reset.note": "这将把工作区重置为与默认分支一致。",
  "common.open": "打开",
  "dialog.releaseNotes.action.getStarted": "开始",
  "dialog.releaseNotes.action.next": "下一步",
  "dialog.releaseNotes.action.hideFuture": "不再显示",
  "dialog.releaseNotes.media.alt": "版本说明预览",
  "toast.project.reloadFailed.title": "无法重新加载 {{project}}",
  "error.server.invalidConfiguration": "配置无效",
  "common.moreCountSuffix": " (还有 {{count}} 个)",
  "common.time.justNow": "刚刚",
  "common.time.minutesAgo.short": "{{count}}分钟前",
  "common.time.hoursAgo.short": "{{count}}小时前",
  "common.time.daysAgo.short": "{{count}}天前",
  "settings.providers.connected.environmentDescription": "已通过环境变量连接",
  "settings.providers.custom.description": "通过基础 URL 添加与 OpenAI 兼容的提供商。",

  "app.server.unreachable": "无法连接到 {{server}}",
  "app.server.retrying": "正在自动重试…",
  "app.server.otherServers": "其他服务器",
  "dialog.server.add.passwordPlaceholder": "密码",
  "session.review.noVcs.createGit.title": "创建 Git 仓库",
  "session.review.noVcs.createGit.description": "在此项目中跟踪、审查和撤消更改",
  "session.review.noVcs.createGit.actionLoading": "正在创建 Git 仓库…",
  "session.review.noVcs.createGit.action": "创建 Git 仓库",
  "session.todo.progress": "已完成 {{done}} 个任务（共 {{total}} 个）",
  "session.question.progress": "{{current}}/{{total}} 个问题",
  "session.header.open.finder": "访达",
  "session.header.open.fileExplorer": "文件资源管理器",
  "session.header.reveal.finder": "在访达中显示",
  "session.header.reveal.fileExplorer": "在文件资源管理器中显示",
  "session.header.reveal.containingFolder": "打开所在文件夹",
  "session.header.open.fileManager": "文件管理器",
  "session.header.open.app.vscode": "VS Code",
  "session.header.open.app.cursor": "Cursor",
  "session.header.open.app.zed": "Zed",
  "session.header.open.app.textmate": "TextMate",
  "session.header.open.app.antigravity": "Antigravity",
  "session.header.open.app.terminal": "终端",
  "session.header.open.app.iterm2": "iTerm2",
  "session.header.open.app.ghostty": "Ghostty",
  "session.header.open.app.warp": "Warp",
  "session.header.open.app.xcode": "Xcode",
  "session.header.open.app.androidStudio": "Android Studio",
  "session.header.open.app.powershell": "PowerShell",
  "session.header.open.app.sublimeText": "Sublime Text",
  "debugBar.ariaLabel": "开发性能诊断",
  "debugBar.providerAriaLabel": "提供商性能诊断",
  "debugBar.ttft.label": "TTFT",
  "debugBar.ttft.tip": "从发送提供商请求到模型首次输出所用的时间。",
  "debugBar.ttfa.label": "TTFA",
  "debugBar.ttfa.tip": "从发送提供商请求到首次输出回答文本所用的时间。",
  "debugBar.tps.label": "TPS",
  "debugBar.tps.tip": "模型首次输出后每秒生成的输出词元数。",
  "debugBar.e2e.label": "E2E",
  "debugBar.e2e.tip": "从发送提供商请求到其响应流结束所用的时间。",
  "debugBar.na": "不适用",
  "debugBar.nav.label": "NAV",
  "debugBar.nav.tip": "最后一次完成的涉及会话页面的路由转换，从路由器启动到稳定后的第一次绘制。",
  "debugBar.fps.label": "FPS",
  "debugBar.fps.tip": "过去 5 秒内的滚动帧率。",
  "debugBar.frame.label": "FRAME",
  "debugBar.frame.tip": "过去 5 秒内最差的帧时间。",
  "debugBar.jank.label": "JANK",
  "debugBar.jank.tip": "过去 5 秒内超过 32ms 的帧。",
  "debugBar.long.label": "LONG",
  "debugBar.long.tip": "过去 5 秒内的阻塞时间和长任务计数。最大任务：{{max}}。",
  "debugBar.delay.label": "DELAY",
  "debugBar.delay.tip": "过去 5 秒内观察到的最差输入延迟。",
  "debugBar.inp.label": "INP",
  "debugBar.inp.tip": "过去 5 秒内的近似交互持续时间。这类似于 INP，而非官方的 Web Vitals INP。",
  "debugBar.cls.label": "CLS",
  "debugBar.cls.tip": "当前应用生命周期的累积布局偏移。",
  "debugBar.mem.label": "MEM",
  "debugBar.mem.tipUnavailable": "使用的 JS 堆与堆限制。仅限 Chromium。",
  "debugBar.mem.tip": "使用的 JS 堆与堆限制。{{used}} / {{limit}}。",
  "debugBar.focus.label": "FOCUS",
  "debugBar.focus.tip": "强制所有交互元素显示焦点样式",
  "debugBar.focus.on": "开",
  "debugBar.focus.off": "关",
  "debugBar.direction.label": "DIR",
  "debugBar.direction.tip": "在不更改所选语言的情况下，强制设置整个应用的布局方向",
  "debugBar.direction.ltr": "LTR",
  "debugBar.direction.rtl": "RTL",
  "common.key.ctrl": "Ctrl",
  "common.key.alt": "Alt",
  "common.key.shift": "Shift",
  "common.key.meta": "Meta",
  "common.key.space": "空格",
  "common.key.backspace": "退格",
  "common.key.enter": "回车",
  "common.key.tab": "Tab",
  "common.key.delete": "Delete",
  "common.key.home": "Home",
  "common.key.end": "End",
  "common.key.pageUp": "Page Up",
  "common.key.pageDown": "Page Down",
  "common.key.insert": "Insert",
  "common.unknown": "未知",
  "error.page.circular": "[循环]",
  "error.serverSDK.noServerAvailable": "无可用服务器",
  "error.serverSDK.serverNotAvailable": "服务器不可用",
  "error.childStore.persistedCacheCreateFailed": "创建持久化缓存失败",
  "error.childStore.persistedProjectMetadataCreateFailed": "创建持久化项目元数据失败",
  "error.childStore.persistedProjectIconCreateFailed": "创建持久化项目图标失败",
  "error.childStore.storeCreateFailed": "创建存储失败",
  "terminal.connectionLost.abnormalClose": "WebSocket 异常关闭：{{code}}",
  "toast.migration.failed.title": "数据迁移失败",
  "command.session.background": "移至后台",
  "session.timeline.notice.finished": "{{actor}} 已完成",
  "session.timeline.notice.failed": "{{actor}} 失败",
  "session.timeline.notice.cancelled": "{{actor}} 已取消",
  "settings.tab.preferences": "偏好设置",
  "settings.tab.notifications": "通知",
  "settings.tab.projects": "项目",
  "settings.tab.extensions": "扩展",
  "settings.preferences.description": "自定义偏好、主题和默认行为",
  "settings.appearance.description": "自定义主题和字体",
  "settings.notifications.description": "选择接收通知和播放声音的时机",
  "settings.shortcuts.description": "自定义常用操作的快捷键",
  "settings.servers.description": "管理服务器连接",
  "settings.projects.title": "项目",
  "settings.projects.description": "管理此服务器上的项目设置",
  "settings.projects.empty": "未找到项目",
  "settings.projects.server.all": "所有服务器",
  "settings.mcps.description": "管理 Model Context Protocol (MCP) 服务器和工具",
  "settings.extensions.description": "管理此服务器上可用的扩展",
  "settings.extensions.tab.mcps": "MCP",
  "settings.extensions.tab.skills": "技能",
  "settings.extensions.availableAll": "可用于所有项目",
  "settings.extensions.manageConfig": "在 opencode.json 中管理",
  "settings.extensions.addSkills": "如何添加技能",
  "dialog.server.authenticate.title": "认证",
  "project.settings.general.description": "管理项目名称和外观",
  "project.settings.scripts": "脚本",
  "project.settings.scripts.description": "配置此项目的脚本",
  "project.settings.extensions.description": "查看此项目可用的扩展",
  "project.settings.extensions.tab.lsps": "LSP",
  "project.settings.extensions.added": "已添加到此项目",
  "project.settings.extensions.shared": "与所有项目共享",
  "project.settings.extensions.lsp.detected": "检测到的语言服务器",
  "project.settings.extensions.lsp.description": "根据文件类型自动检测",
  "project.settings.extensions.setupRequired": "需要设置",
  "settings.general.section.general": "常规",
  "common.viewAll": "查看全部",
  "session.new.workspace.local.tooltip": "使用当前检出",
  "session.new.workspace.new.tooltip": "创建隔离检出",
  "session.new.workspace.fromBranch": "基于 {{branch}}",
  "session.new.workspace.trigger.tooltip": "选择会话的运行位置",
  "session.new.workspace.search.placeholder": "搜索工作区",
  "settings.tab.workspaces": "工作区",
  "settings.workspaces.filter.all": "所有项目",
  "settings.workspaces.empty": "没有工作区",
  "settings.workspaces.count.one": "{{count}} 个工作区",
  "settings.workspaces.count.other": "{{count}} 个工作区",
  "settings.workspaces.sessions.one": "{{project}} 中有 {{count}} 个会话",
  "settings.workspaces.sessions.other": "{{project}} 中有 {{count}} 个会话",
  "settings.workspaces.lastActiveSession": "上次活跃的会话",
  "settings.workspaces.deleteAll": "删除所有工作区",
  "settings.workspaces.delete.warning": "工作区目录和分支将被永久移除，包括下方显示的所有未合并更改。",
  "settings.workspaces.deleteAll.warning": "具有未合并更改、关联会话或活动位置的工作树将被保留。",
  "settings.workspaces.delete.blocked.active": "无法删除活跃工作区。",
  "settings.workspaces.delete.blocked.linked": "关联的会话将保留，但其工作目录会被永久移除。",
  "settings.workspaces.default.title": "默认环境",
  "settings.workspaces.default.description": "选择新会话的启动位置",
  "settings.workspaces.default.lastUsed": "各项目上次使用的位置",
  "settings.workspaces.default.local": "本地目录",
  "settings.workspaces.default.new": "新建工作区",
  "workspace.move.title": "移至工作区",
  "workspace.move.menu.title": "将会话移至",
  "workspace.move.failed": "移动会话失败",
  "workspace.lifecycle.creating": "正在创建工作区",
  "workspace.lifecycle.created": "工作区已创建",
  "workspace.lifecycle.starting": "正在启动会话",
  "workspace.onboarding.title": "使用工作区隔离会话",
  "workspace.onboarding.description": "每个会话都有独立的检出，因此不会干扰本地仓库",
  "workspace.lifecycle.moving": "正在移至工作区",
  "workspace.lifecycle.set": "工作区已设置",
  "session.summary.title": "会话详情",
  "session.summary.noBranch": "无分支",
  "session.summary.basedOn": "基于 {{branch}}",
  "desktop.menu.installCli": "安装 CLI...",
  "desktop.cli.installed.title": "CLI 已安装",
  "desktop.cli.installed.message": "CLI 已安装到 {{path}}\n\n请重启终端以使用“opencode2”命令。",
  "desktop.cli.failed.title": "安装失败",
  "desktop.cli.failed.message": "安装 CLI 失败：{{error}}",
  "command.project.copyID": "复制项目 ID",
  "command.session.copyID": "复制会话 ID",
  "server.row.incompatible": "此服务器正在运行 OpenTAG {{version}}，与此应用不兼容。请升级到 OpenTAG V2 以继续。",
  "toast.session.copyID.failed.title": "复制会话 ID 失败",
  "toast.session.copyID.failed.description": "复制会话 ID 时出错",
  "toast.project.copyID.failed.title": "复制项目 ID 失败",
  "toast.project.copyID.failed.description": "复制项目 ID 时出错",
  "error.page.title.status": "服务器请求失败",
  "error.page.description.status": "服务器返回了 HTTP {{status}} 响应。",
  "error.page.action.reload": "重新加载",
  "session.error.incompatible": "不支持此服务器版本",
  "session.error.incompatible.description":
    "{{server}} 正在运行 OpenTAG {{version}}，与此应用不兼容。请将服务器升级到 OpenTAG V2 以继续。",
  "session.background.moveInline": "按 {{keybind}} 将正在运行的任务移至后台",
  "session.background.running": "任务正在后台运行",
  "session.background.runningCount.one": "{{count}} 个任务正在后台运行",
  "session.background.runningCount.other": "{{count}} 个任务正在后台运行",
  "settings.general.row.terminalPlacement.title": "终端位置",
  "settings.general.row.terminalPlacement.description": "选择会话中终端的打开位置",
  "settings.general.row.terminalPlacement.side": "侧边",
  "settings.general.row.terminalPlacement.bottom": "底部",
  "session.location.unavailable": "会话位置不可用",
  "session.location.description": "请选择其他目录以继续此会话。",
  "session.location.choose": "选择目录",
  "session.location.worktree": "选择 worktree",
  "session.location.worktreesFailed": "无法加载 worktree",
  "session.location.moving": "正在移动会话…",
  "dialog.server.menu.hide": "从项目列表中隐藏",
  "dialog.server.menu.show": "在项目列表中显示",
  "session.queue.count.one": "{{count}} 个已排队",
  "session.queue.count.other": "{{count}} 个已排队",
  "session.queue.steer": "引导",
  "session.queue.send": "发送",
  "session.queue.steerTooltip": "发送但不中断",
  "session.queue.remove": "移除",
  "session.queue.reorder": "重新排列已排队的提示词",
  "session.new.worktree.creating": "正在创建 worktree",
  "settings.backToApp": "返回应用",
  "settings.appearance.section.experimental": "实验性功能",
  "settings.appearance.row.tabs.title": "标签页",
  "settings.appearance.row.tabs.description": "选择会话标签页的排列方式",
  "settings.appearance.row.tabs.horizontal": "水平",
  "settings.appearance.row.tabs.vertical": "垂直",
  "settings.general.row.followUpBehavior.title": "后续消息行为",
  "settings.general.row.followUpBehavior.description":
    "选择将后续消息加入队列还是引导当前轮次。使用 {{keybind}} 切换。",
  "settings.general.row.followUpBehavior.queue": "加入队列",
  "settings.general.row.followUpBehavior.steer": "引导",
  "settings.general.row.reasoningMode.title": "模型推理",
  "settings.general.row.reasoningMode.description": "选择模型推理在时间线中的显示方式",
  "settings.general.row.reasoningMode.hidden": "隐藏",
  "settings.general.row.reasoningMode.compact": "紧凑",
  "settings.general.row.reasoningMode.full": "完整",
  "session.new.workspace.createFrom": "创建自",
  "session.new.workspace.branch.search.placeholder": "搜索分支",
  "toast.migration.progress.clearingOldEvents": "正在清除旧事件",
  "toast.migration.progress.migratingSessions": "正在迁移会话",
  "session.new.workspace.existingLabel": "工作树",
  "desktop.onboarding.defaultProject": "默认项目",

  "home.projects.all": "所有项目",
  "session.tab.files": "文件",
  "session.files.openTabs": "打开文件",
  "session.tab.usage": "用法",
  "session.view.select": "课次视图",
  "session.background.moveTasks": "将{{tasks}}移至后台",
  "session.background.moveRunning": "移至背景",
  "session.background.inBackground": "在后台运行{{tasks}}",
  "session.background.tasksRunning.one": "{{count}}个后台任务正在运行",
  "session.background.tasksRunning.other": "{{count}}个后台任务正在运行",
  "session.background.combine": "{{first}}和{{second}}",
  "session.background.shell.one": "{{count}}个shell",
  "session.background.shell.other": "{{count}}个贝壳",
  "session.background.subagent.one": "{{count}}个子代理",
  "session.background.subagent.other": "{{count}}个子代理",
  "session.timeline.working": "工作中",
  "session.review.wrapLines": "换行",
  "session.websearch.title": "第三方网页搜索",
  "session.websearch.description": "选择搜索提供商代理用于搜索网页",
  "session.websearch.provider": "搜索提供商",
  "session.websearch.any": "任何",
  "session.websearch.disable": "不使用搜索",
  "session.websearch.enable": "启用",
  "session.websearch.loadFailed": "无法加载搜索提供程序。",
  "session.websearch.empty": "没有可用的搜索提供程序。",
  "session.websearch.failed": "无法保存您的选择。请重试。",
  "session.websearch.retry": "重试",
  "session.new.worktree.draftPlaceholder": "在准备工作树时起草跟进……",
  "session.search.placeholder": "查找...",
  "session.search.noResults": "无匹配项",
  "titlebar.tabs": "标签页",
  "titlebar.channel.local": "本地",
  "titlebar.channel.dev": "开发",
  "titlebar.channel.beta": "测试版",
  "titlebar.toggleDebugTools": "切换调试工具",
  "settings.tab.experimental": "实验",
  "settings.experimental.description": "尝试实验性功能",
  "settings.tab.about": "关于",
  "settings.about.version": "版本{{version}}",
  "settings.about.devVersion": "发展",
  "settings.about.license": "根据麻省理工学院许可证发布",
  "settings.about.writtenBy": "作者",
  "settings.about.illustratedBy": "图示：",
  "settings.about.and": "和",
  "settings.about.otherContributor.one": "{{count}}其他",
  "settings.about.otherContributor.other": "其他{{count}}人",
  "settings.about.firstPublished": "首次在美国密苏里州发布",
  "settings.about.firstIllustrated": "首次在英国伦敦展出",
  "settings.about.website": "www.opencode.ai",
  "settings.about.description": "OpenTAG ，开源编码代理",
  "settings.about.trademark": "opentag是Anomaly Innovations, Inc.的注册商标。",
  "settings.about.typeset": "Inter和IBM Plex Mono中的排版",
  "settings.about.tagline": "没有您，人工智能无法构建出色的软件",
  "settings.about.copyright": "© Anomaly Innovations, Inc.",
  "project.settings.title": "编辑项目",
  "settings.timeline.title": "时间表",
  "settings.timeline.detail": "时间轴详细信息",
  "settings.timeline.description": "选择时间轴上显示的活动量。消息始终可见。",
  "settings.timeline.preset.everything": "一切",
  "settings.timeline.preset.detailed": "详情",
  "settings.timeline.preset.compact": "紧凑型",
  "settings.timeline.preset.quiet": "安静",
  "settings.timeline.preset.text-only": "仅文本",
  "settings.timeline.description.everything": "单独显示所有活动。 展开shell输出、编辑和思考。",
  "settings.timeline.description.detailed": "展开shell输出和编辑。 单独显示子代理，并在已使用中对其他活动进行分组。",
  "settings.timeline.description.compact": "隐藏详细信息，将工具分组，并折叠思考内容。",
  "settings.timeline.description.quiet": "对已使用的编辑和子代理进行分组。隐藏其他活动。",
  "settings.timeline.description.text-only": "隐藏所有活动。仅显示消息。",
  "settings.timeline.description.custom": "为每个活动类别使用您选择的位置和详细信息。",
  "settings.timeline.custom": "自定义",
  "settings.timeline.advanced": "高级",
  "settings.timeline.advanced.description": "设置每个活动类别的位置和详细信息。",
  "settings.timeline.category.shell": "壳牌",
  "settings.timeline.category.edit": "编辑",
  "settings.timeline.category.thinking": "思考",
  "settings.timeline.category.subagents": "子代理",
  "settings.timeline.category.notices": "注意事项",
  "settings.timeline.category.tools": "其他工具",
  "settings.general.row.mobileDiffWrap.description": "在移动设备差异中换行，而不是水平滚动",

  "provider.connect.error.unsupportedFields": "此身份验证表单包含不受支持的字段",
  "session.review.filesChangedCount.one": "{{count}} 个文件已更改",
  "session.review.filesChangedCount.other": "{{count}} 个文件已更改",
  "settings.about.writtenByNames": "作者：{{names}}",
  "settings.about.illustratedByNames": "插图由{{names}}",
  "ssh.label": "SSH",
  "ssh.offline": "未连接到 {{host}}。您的草稿已保存；远程工作可能仍在运行。",
  "ssh.placeholder": "ssh user@example.com",
  "ssh.add": "添加 SSH 服务器",
  "ssh.server.menu.label": "SSH 服务器",
  "ssh.target": "主机或 SSH 命令",
  "ssh.connect": "连接",
  "ssh.connectTo": "连接到 {{host}}",
  "ssh.authenticate": "SSH 验证",
  "ssh.action.authenticate": "验证",
  "ssh.session.disconnected": "SSH 连接不活动",
  "ssh.session.connecting": "正在连接到 SSH 服务器",
  "ssh.session.reconnectDescription": "重新连接以查看此会话并继续工作。您的远程会话已保存。",
  "ssh.session.reconnect": "重新连接",
  "ssh.authenticationRequired": "需要对 {{host}} 进行身份验证",
  "ssh.trust": "信任并连接",
  "ssh.continue": "继续",
  "ssh.retry": "重试",
  "ssh.update": "更新并重新连接",
  "ssh.openProject": "打开项目",
  "ssh.project": "在 {{host}} 上打开项目",
  "ssh.disconnect": "断开连接",
  "ssh.forget": "忘记连接",
  "ssh.stage.disconnected": "已断开连接。远程服务器仍在运行。",
  "ssh.stage.connecting": "正在通过 SSH 连接…",
  "ssh.stage.checking": "正在检查 OpenTAG…",
  "ssh.stage.downloading": "正在下载服务器…",
  "ssh.stage.uploading": "正在上传服务器…",
  "ssh.stage.starting": "正在连接到 OpenTAG…",
  "ssh.stage.ready": "已连接",
  "ssh.stage.authentication": "需要身份验证",
  "ssh.stage.incompatible": "需要更新服务器",
  "ssh.stage.failed": "连接失败",
  "ssh.error.input": "请输入主机或 SSH 连接命令。不允许远程命令和不支持的 SSH 选项。",
  "ssh.error.connection": "无法建立 SSH 连接。请检查您的网络和 SSH 配置。",
  "ssh.error.platform": "此远程平台不受支持。自动设置目前需要在 x64 或 arm64 上运行的 Linux 或 macOS。",
  "ssh.error.version": "在连接之前，远程服务必须与此桌面版本匹配。",
  "ssh.error.install": "无法安装远程服务器。请检查连接性、磁盘空间，并确认已安装 tar。",
  "ssh.error.unpublished": "此桌面版本没有发布远程服务器。对于开发版本，请在主机上安装并启动 V2，然后重试。",
  "ssh.error.service": "SSH 已连接，但 OpenTAG 服务器未准备就绪。",
  "ssh.error.host-key": "无法验证主机的身份。在更新 SSH 已知主机之前，请验证其指纹。",
  "ssh.error.ssh-missing": "未找到 OpenSSH。请安装 OpenSSH 客户端，并确保 ssh 可在 PATH 中使用。",
  "command.browser.open": "打开浏览器",
  "command.browser.reload": "重新加载浏览器页面",
  "command.session.summary.toggle": "切换摘要",
  "common.color.orange": "橙色",
  "common.color.yellow": "黄色",
  "common.color.cyan": "青色",
  "common.color.green": "绿色",
  "common.color.red": "红色",
  "common.color.pink": "粉色",
  "common.color.blue": "蓝色",
  "common.color.purple": "紫色",
  "common.color.gray": "灰色",
  "mcp.auth.interactiveForm": "MCP 服务器 {{name}} 需要交互式身份验证表单",
  "server.connect.title": "连接到服务器",
  "server.connect.description": "输入您的服务器地址和密码以开始。",
  "server.connect.button": "连接",
  "server.connect.address.invalid": "请输入有效的 HTTP 或 HTTPS 服务器地址。",
  "server.connect.failed": "无法连接。请检查服务器地址和密码，然后重试。",
  "server.connect.pair.description": "Or connect from the OpenTAG portal: open it and choose “Open assistant”.",
  "server.connect.scan": "扫描二维码",
  "server.connect.scan.description": "将摄像头对准 opencode pair 显示的二维码。",
  "server.connect.scan.invalid": "这不是 OpenTAG 配对码。请扫描 opencode pair 显示的二维码。",
  "server.connect.camera": "正在配对摄像头",
  "server.connect.camera.starting": "正在打开摄像头…",
  "server.connect.mixedContent": "无法从 HTTPS 页面连接此 HTTP 服务器。请使用 HTTPS 服务器地址。",
  "server.connect.camera.insecure": "扫描二维码需要通过 HTTPS 打开此页面或在本地主机上打开。",
  "server.connect.camera.unavailable": "此浏览器无法使用摄像头。请手动输入连接详情。",
  "server.connect.camera.error": "无法打开摄像头。请允许摄像头访问或手动输入连接详情。",
  "dialog.server.menu.remove": "移除",
  "file.error.notFound": "未找到文件：{{name}}",
  "toast.migration.progress.migratingSessions.current": "正在迁移会话 {{current}}",
  "toast.migration.progress.migratingSessions.progress": "正在迁移会话 {{current}}/{{total}}",
  "toast.migration.progress.working": "正在迁移数据",
  "toast.migration.progress.working.current": "正在迁移数据 {{current}}",
  "toast.migration.progress.working.progress": "正在迁移数据 {{current}}/{{total}}",
  "home.workspaceTip": "在新工作区中开始下一个会话以保持更改独立",
  "session.tab.browser": "浏览器",
  "session.tab.add": "添加标签页",
  "session.queue.attachments.one": "添加 {{count}} 个附件",
  "session.queue.attachments.other": "添加 {{count}} 个附件",
  "session.browser.address": "浏览器地址",
  "session.browser.replaced": "浏览器控件已移动到另一个桌面窗口。",
  "session.browser.unsupported": "此桌面应用程序不支持浏览器面板。",
  "session.browser.suspended": "浏览器已挂起。请与此会话交互以重新连接。",
  "session.browser.address.placeholder": "输入 URL",
  "session.browser.empty.title": "输入 URL",
  "session.browser.empty.description": "或提示“在应用内浏览器中打开”",
  "session.browser.failed.title": "无法访问 URL",
  "session.browser.failed.description": "请检查 URL 和网络连接，然后重试。",
  "settings.backToSettings": "返回设置",
  "settings.backToProjects": "返回项目",
  "settings.search.placeholder": "搜索",
  "settings.search.results": "设置结果",
  "settings.search.group.pages": "页面",
  "settings.search.group.settings": "设置",
  "settings.search.group.projects": "项目",
  "settings.search.group.servers": "服务器",
  "settings.search.result": "{{title}}，{{scope}}，{{page}}",
  "settings.search.page": "{{title}}，{{scope}}",
  "settings.search.result.unscoped": "{{title}}，{{page}}",
  "settings.search.empty": "未找到 {{query}} 的结果",
  "settings.search.refine": "缩小搜索范围以查看更多具体结果。",
  "settings.server.description": "管理此服务器的连接和偏好设置",
  "settings.server.section.connection": "连接",
  "settings.server.preferences.websearch.title": "第三方搜索",
  "settings.server.preferences.websearch.description": "选择代理用来在网络上搜索的搜索提供商",
  "settings.projects.search.placeholder": "搜索项目",
  "project.settings.name.title": "项目名称",
  "project.settings.name.description": "在 OpenTAG 中此项目显示的名称",
  "project.settings.icon.description": "建议：128×128 像素。点击或拖动上传图片。",
  "project.settings.color.description": "当未设置自定义图片时用于项目图标",
  "project.settings.worktree.startup.description": "在创建新工作树后运行一次",
  "project.settings.worktree.startup.hint.base": "使用 $OPENCODE_WORKTREE_BASE 作为基础工作树。",
  "project.settings.worktree.startup.hint.new": "使用 $OPENCODE_WORKTREE_PATH 作为新工作树。",
  "project.settings.extensions.empty.mcps.title": "尚无 MCP",
  "project.settings.extensions.empty.mcps.description": "可用于 OpenTAG 的 MCP 将显示在这里",
  "project.settings.extensions.empty.plugins.title": "尚无插件",
  "project.settings.extensions.empty.plugins.description": "可用于 OpenTAG 的插件将显示在这里",
  "project.settings.extensions.empty.skills.title": "尚无技能",
  "project.settings.extensions.empty.skills.description": "可用于 OpenTAG 的技能将显示在这里",
  "project.settings.extensions.lsp.configured": "已配置的语言服务器",
  "project.settings.extensions.lsp.status.enabled": "在配置中启用",
  "project.settings.extensions.lsp.status.disabled": "在配置中禁用",
  "project.settings.extensions.lsp.empty.title": "尚未配置语言服务器",
  "project.settings.extensions.lsp.empty.description": "为此项目配置的语言服务器将显示在这里",
  "project.settings.extensions.lsp.disabled.title": "语言服务器已禁用",
  "project.settings.extensions.lsp.disabled.description": "此项目配置中已禁用 LSP",
  "project.settings.extensions.lsp.loadFailed": "无法加载语言服务器配置",
  "project.settings.extensions.lsp.retry": "重试",
  "settings.timeline.summary": "{{preset}}：",
  "settings.timeline.group": "分组",
  "settings.timeline.collapse": "折叠",
  "settings.timeline.visibility.show": "显示",
  "settings.timeline.visibility.hide": "隐藏",
  "settings.timeline.visibility.label": "{{activity}} 可见性",
  "settings.timeline.grouped.label": "{{activity}} 已分组",
  "settings.timeline.collapsed.label": "{{activity}} 已折叠",
  "session.new.workspace.search.empty": "没有匹配的工作树",
  "settings.workspaces.description": "查看工作树并管理磁盘使用",
  "settings.workspaces.empty.description": "在 OpenTAG 中创建的工作树将显示在此处",
  "settings.workspaces.sessions.filtered.one": "{{count}} 个会话",
  "settings.workspaces.sessions.filtered.other": "{{count}} 个会话",
  "settings.workspaces.deleteAll.confirm.one": "这将永久删除 {{count}} 个选定的工作树。",
  "settings.workspaces.deleteAll.confirm.other": "这将永久删除 {{count}} 个选定的工作树。",
  "settings.workspaces.deleteWithoutSessions": "删除没有会话的工作树",
  "settings.workspaces.deleteWithoutSessions.confirm.one": "这将永久删除 {{count}} 个没有关联会话的工作树。",
  "settings.workspaces.deleteWithoutSessions.confirm.other": "这将永久删除 {{count}} 个没有关联会话的工作树。",
  "settings.workspaces.deleteWithoutSessions.warning": "有未合并更改或活跃位置的工作树将被保留。",
  "settings.workspaces.delete.button": "删除工作树",
  "workspace.lifecycle.deleting": "正在删除…",
  "session.summary.tooltip": "摘要",
  "session.summary.server": "扩展",
  "session.summary.chooseProject": "选择项目",
  "session.summary.mcp.onCreation": "在创建工作树时适用",
  "session.summary.mcp.prepareFailed": "无法准备 MCP 服务器",
  "session.summary.mcp.unavailable": "MCP 服务器 {{name}} 在此工作树中不可用。",
  "session.summary.mcp.signInBeforeSend": "在发送提示之前，请先登录 {{name}}。",
  "session.summary.mcp.notReady": "MCP 服务器 {{name}} 尚未准备好。在发送提示前请先解决其连接问题。",
  "session.summary.mcp": "MCP",
  "session.summary.mcp.title": "已配置的 MCP 服务器",
  "session.summary.plugins": "插件",
  "session.summary.plugins.configured": "已配置的插件",
  "session.summary.skills": "技能",
  "session.summary.skills.configured": "已配置的技能",
  "session.summary.lsp": "LSP",
  "session.summary.failed": "失败",
  "session.summary.retry": "重试",
  "session.summary.connecting": "正在连接…",
  "session.summary.needsAuth": "需要登录",
  "session.summary.configure": "配置文件",
  "session.summary.copyConfigPath": "复制配置文件路径",
  "session.summary.configFileMissing": "未找到配置文件",
  "session.summary.mcp.empty": "未配置 MCP 服务器",
  "session.summary.mcp.add": "在 opencode.json 中添加服务器",
  "session.summary.plugins.manage": "在 opencode.json 中管理插件",
  "session.summary.plugins.empty": "未配置插件",
  "session.summary.plugins.add": "在 opencode.json 中添加插件",
  "session.summary.skills.manage": "在 opencode.json 中管理技能",
  "session.summary.skills.empty": "未配置技能",
  "session.summary.skills.add": "在 opencode.json 中添加技能",
  "session.summary.lsp.configured": "已配置的 LSP",
  "session.summary.lsp.empty": "未配置 LSP 服务器",
  "session.summary.lsp.manage": "在 opencode.json 中管理 LSP",
  "workspace.delete.confirm": "删除“{{name}}”吗？",
  "workspace.delete.location": "位置",
  "context.breakdown.note": "输入词元的大致细分。“其他”包含工具定义和开销。",
  "settings.search.empty.query": "“{{query}}”",
} satisfies Partial<Record<Keys, string>>

export default dict
